/**
 * MT Blog Post — Table of Contents Auto-Generation & Active Tracking
 */
(function () {
  'use strict';

  function initBlogPost() {
    const container = document.querySelector('.mt-blog-post');
    if (!container) return;

    const toc = container.querySelector('.mt-blog-post__toc');
    const article = container.querySelector('.mt-blog-post__article');
    const content = article ? article.querySelector('.mt-blog-post__content') : null;

    if (!toc || !content) return;

    // 1. Auto-generate TOC from article headings (h2, h3)
    const headings = content.querySelectorAll('h2, h3');
    if (headings.length > 0) {
      const tocList = toc.querySelector('.mt-blog-post__toc-list');
      if (tocList) {
        // Clear existing items
        tocList.innerHTML = '';

        headings.forEach((heading, index) => {
          // Add ID to heading for anchor linking
          const id = heading.id || `bp-auto-heading-${index}`;
          heading.id = id;

          // Create TOC item
          const li = document.createElement('li');
          li.className = 'mt-blog-post__toc-item';

          const a = document.createElement('a');
          a.className = 'mt-blog-post__toc-link';
          a.href = `#${id}`;
          a.textContent = heading.textContent;

          // Indent h3 slightly if needed (optional)
          if (heading.tagName === 'H3') {
            a.style.paddingLeft = '24px';
            a.style.fontSize = '12px';
          }

          li.appendChild(a);
          tocList.appendChild(li);
        });
      }
    }

    // 2. Active tracking on scroll
    const tocLinks = toc.querySelectorAll('.mt-blog-post__toc-link');
    if (!tocLinks.length) return;

    const trackedHeadings = [];
    tocLinks.forEach((link) => {
      const id = link.getAttribute('href').replace('#', '');
      const el = document.getElementById(id);
      if (el) trackedHeadings.push(el);
    });

    if (!trackedHeadings.length) return;

    let ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateActiveToc();
        ticking = false;
      });
    }

    function updateActiveToc() {
      const scrollY = window.scrollY + 120;
      let activeIndex = 0;

      trackedHeadings.forEach((h, i) => {
        if (h.offsetTop <= scrollY) {
          activeIndex = i;
        }
      });

      tocLinks.forEach((l, i) => {
        l.classList.toggle('is-active', i === activeIndex);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    updateActiveToc();

    // 3. Smooth scroll for ToC links
    tocLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const id = link.getAttribute('href').replace('#', '');
        const target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogPost);
  } else {
    initBlogPost();
  }

  // ── Subscribe: pure native form, no JS interference ─────────────
  function initSubscribeForms() {
    // Show success message if redirected back with ?bp_subscribed=true
    if (window.location.search.includes('bp_subscribed=true')) {
      var form = document.querySelector('.mt-blog-post__subscribe-form');
      if (form) {
        var successEl = form.querySelector('.mt-blog-post__subscribe-success');
        var emailInput = form.querySelector('.mt-blog-post__subscribe-email');
        var btn = form.querySelector('.mt-blog-post__subscribe-btn');
        var successMsg = (btn && btn.getAttribute('data-success')) || 'Thank you for subscribing!';
        if (successEl) { successEl.textContent = successMsg; successEl.style.display = 'block'; }
        if (emailInput) emailInput.style.display = 'none';
        if (btn) btn.style.display = 'none';
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    // No submit listener — browser handles validation natively via required + type="email"
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSubscribeForms);
  } else {
    initSubscribeForms();
  }

  // ── Article Nav: dynamic prev/next switcher ─────────────────────
  function initArticleNav() {
    // Collect unique section IDs from all nav arrows
    var sectionIds = [];
    document.querySelectorAll('.mt-blog-post__article-nav-arrow[data-nav]').forEach(function(btn) {
      var id = btn.dataset.nav;
      if (sectionIds.indexOf(id) === -1) sectionIds.push(id);
    });

    sectionIds.forEach(function(sectionId) {
      const dataEl = document.getElementById('article-nav-data-' + sectionId);
      if (!dataEl) return;

      const data = JSON.parse(dataEl.textContent);
      const articles = data.articles;
      const currentIndex = data.currentIndex;
      const nav = document.getElementById('article-nav-' + sectionId);
      if (!nav) return;

      const prevBtn = document.querySelector('.mt-blog-post__article-nav-arrow--prev[data-nav="' + sectionId + '"]');
      const nextBtn = document.querySelector('.mt-blog-post__article-nav-arrow--next[data-nav="' + sectionId + '"]');
      const prevItem = nav.querySelector('.mt-blog-post__article-nav-item--prev');
      const nextItem = nav.querySelector('.mt-blog-post__article-nav-item--next');

      // All articles except current, circular loop — never disabled
      const navArticles = articles.filter(function(_, i) { return i !== currentIndex; });
      var offset = 0;

      function mod(n, m) { return ((n % m) + m) % m; }

      function render() {
        var leftArt  = navArticles[mod(offset, navArticles.length)];
        var rightArt = navArticles[mod(offset + 1, navArticles.length)];

        if (prevItem && leftArt) {
          prevItem.href = leftArt.url;
          prevItem.querySelector('.mt-blog-post__article-nav-title').textContent = leftArt.title;
          prevItem.style.display = '';
        }
        if (nextItem && rightArt) {
          nextItem.href = rightArt.url;
          nextItem.querySelector('.mt-blog-post__article-nav-title').textContent = rightArt.title;
          nextItem.style.display = '';
        }

        // Never disabled — always show both arrows
        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = false;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          offset = mod(offset - 2, navArticles.length);
          render();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          offset = mod(offset + 2, navArticles.length);
          render();
        });
      }

      render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleNav);
  } else {
    initArticleNav();
  }
})();
